import { render } from "./BpmnSwimLaneTitle.vue?vue&type=template&id=52c01a28&scoped=true"
import script from "./BpmnSwimLaneTitle.vue?vue&type=script&lang=js"
export * from "./BpmnSwimLaneTitle.vue?vue&type=script&lang=js"

import "./BpmnSwimLaneTitle.vue?vue&type=style&index=0&id=52c01a28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c01a28"]])

export default __exports__